import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const SectionTitle = ({ children }) => (
    <Typography
        component="h2"
        sx={{
            fontWeight: 900,
            fontSize: { xs: 18, md: 20 },
            textTransform: "uppercase",
            mb: 1.5,
            mt: 3,
            color: "#111",
        }}
    >
        {children}
    </Typography>
);

const Paragraph = ({ children, sx }) => (
    <Typography
        component="p"
        sx={{
            fontSize: { xs: 13.5, md: 14.5 },
            lineHeight: 1.55,
            color: "#222",
            mb: 1.25,
            ...sx,
        }}
    >
        {children}
    </Typography>
);

const Ul = ({ children }) => (
    <Box
        component="ul"
        sx={{
            pl: 2.25,
            mt: 0.5,
            mb: 1.5,
            "& li": {
                fontSize: { xs: 13.5, md: 14.5 },
                lineHeight: 1.55,
                color: "#222",
                mb: 0.75,
            },
        }}
    >
        {children}
    </Box>
);

const Ol = ({ children }) => (
    <Box
        component="ol"
        sx={{
            pl: 2.25,
            mt: 0.5,
            mb: 1.5,
            "& li": {
                fontSize: { xs: 13.5, md: 14.5 },
                lineHeight: 1.55,
                color: "#222",
                mb: 0.75,
            },
        }}
    >
        {children}
    </Box>
);

export default function ShippingWaysContent() {
    return (
        <Box sx={{ width: "100%", py: { xs: 2, md: 3 } }}>
            <Box sx={{ width: "100%", maxWidth: 980, mx: "auto", px: { xs: 2, md: 0 } }}>
                <Typography
                    component="h1"
                    sx={{
                        textAlign: "start",
                        fontWeight: 900,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                        fontSize: { xs: 20, md: 30 },
                        mb: 2,
                        color: "#111",
                    }}
                >
                    ΤΡΟΠΟΙ ΑΠΟΣΤΟΛΗΣ
                </Typography>

                <Paper
                    elevation={0}
                    sx={{
                        bgcolor: "#fff",
                        borderRadius: "18px",
                        border: "1px solid #E9E9E9",
                        p: { xs: 2.25, md: 4 },
                    }}
                >
                    <SectionTitle>ΑΠΟΣΤΟΛΗ ΠΡΟΣ ΕΛΛΑΔΑ</SectionTitle>

                    <Paragraph>
                        Οι αποστολές των παραγγελιών μπορούν να διεκπεραιωθούν είτε με την εταιρεία μεταφορών ή courier
                        με την οποία συνεργάζεστε (τόσο για την Ελλάδα όσο και για την Κύπρο), είτε με τις εταιρείες
                        μεταφορών με τις οποίες συνεργαζόμαστε εμείς.
                    </Paragraph>

                    <Paragraph sx={{ fontWeight: 700, mb: 0.75 }}>Συγκεκριμένα:</Paragraph>
                    <Ul>
                        <li>Μεταφορική «ΜΠΕΛΕΧΑΣ» για την Αθήνα (αποστολή καθημερινά).</li>
                        <li>Μεταφορική «ΚΑΣΑΠΗΣ» για Θεσσαλονίκη (αποστολή από Δευτέρα έως Πέμπτη).</li>
                    </Ul>

                    <Paragraph sx={{ fontWeight: 700, mb: 0.75 }}>
                        Οι χρεώσεις για τη μεταφορική εταιρεία «ΜΠΕΛΕΧΑΣ» είναι:
                    </Paragraph>
                    <Ul>
                        <li>26,50 € ανά παλέτα (κάθε παλέτα περιέχει 10 κιβώτια ή περισσότερα)</li>
                        <li>2,60 € το κιβώτιο</li>
                    </Ul>

                    <Paragraph sx={{ fontWeight: 700, mb: 0.75 }}>
                        Οι χρεώσεις για τη μεταφορική εταιρεία «ΚΑΣΑΠΗΣ» είναι:
                    </Paragraph>
                    <Ul>
                        <li>28,00 € ανά παλέτα (κάθε παλέτα περιέχει 10 κιβώτια ή περισσότερα)</li>
                        <li>2,80 € το κιβώτιο</li>
                    </Ul>

                    <Paragraph sx={{ fontSize: { xs: 12.5, md: 13.5 }, color: "#444" }}>
                        *Οι παραπάνω τιμές δεν περιλαμβάνουν ΦΠΑ.
                    </Paragraph>

                    <Paragraph sx={{ mt: 1.5 }}>
                        <Box component="span" sx={{ fontWeight: 900 }}>
                            ΣΗΜΕΙΩΣΗ:
                        </Box>{" "}
                        ανεξάρτητα με την επιλογή της μεταφορικής εταιρείας (συνεργαζόμενη με εσάς ή προτεινόμενη από εμάς)
                        τα μεταφορικά έξοδα επιβαρύνουν τον πελάτη και χρεώνονται από την μεταφορική μετά την απόδειξη
                        πληρωμής της παραγγελίας. Για οποιαδήποτε διευκρίνιση σχετικά με την κοστολόγηση της μεταφοράς,
                        μπορείτε να επικοινωνείτε με την εταιρεία μεταφορών που έχετε επιλέξει.
                    </Paragraph>

                    <Paragraph sx={{ mt: 1.25 }}>
                        Για αποστολές εκτός Αθηνών με το μεταφορέα μας, θα έχετε την επιλογή να μεταφορτώσετε την παραγγελία
                        σε συνεργαζόμενη με εσάς μεταφορική εταιρεία (ισχύει για Ελλάδα και Κύπρο). Σε αυτή την περίπτωση,
                        θα πρέπει να καταχωρίσετε τις παρακάτω πληροφορίες για την εταιρεία που θα κάνει τη μεταφόρτωση:
                    </Paragraph>

                    <Ol>
                        <li>Επωνυμία της εταιρείας</li>
                        <li>Διεύθυνση της εταιρείας</li>
                        <li>Περιοχή &amp; ταχυδρομικό κώδικα</li>
                        <li>Τηλέφωνο Επικοινωνίας</li>
                    </Ol>

                    <SectionTitle>ΑΠΟΣΤΟΛΗ ΠΡΟΣ ΚΥΠΡΟ</SectionTitle>
                    <Paragraph>
                        Η εκτέλεση της παραγγελίας σας και η παράδοση των προϊόντων θα πραγματοποιούνται εντός δυο (2)
                        εργασίμων ημερών για την Ελλάδα και εντός πέντε (5) εργάσιμων ημερών για την Κύπρο, από τη στιγμή
                        που θα λάβουμε την προπληρωμή της παραγγελίας σας. Κατά περιπτώσεις, οι χρόνοι παράδοσης θα
                        ανακοινώνονται στην αντίστοιχη σελίδα του κάθε προϊόντος. Σε περιπτώσεις που ο όγκος των παραγγελιών
                        δε μας επιτρέπει να ανταποκριθούμε στο παραπάνω χρονοδιάγραμμα, θα λαμβάνετε από εμάς ενημέρωση για
                        τον επαναπροσδιορισμό του.
                    </Paragraph>

                    <SectionTitle>ΠΕΡΙΠΤΩΣΗ ΖΗΜΙΑΣ ΚΑΤΑ ΤΗ ΜΕΤΑΦΟΡΑ</SectionTitle>
                    <Paragraph>
                        Η ιδιοκτησία του προϊόντος μεταφέρεται και ο κίνδυνος μετατοπίζεται μετά την πλήρη εξόφληση της
                        παραγγελίας.
                    </Paragraph>
                    <Paragraph>
                        Σε περίπτωση παράδοσης οποιασδήποτε παραγγελίας με προφανείς ζημίες κατά τη μεταφορά, παρακαλούμε
                        διεκδικήστε άμεσα αυτές τις ζημίες από την εταιρεία παράδοσης. Η εταιρεία μας δεν φέρει καμία ευθύνη
                        για πιθανές ζημίες κατά τη μεταφορά. Ωστόσο, μπορείτε να επικοινωνήσετε και μαζί μας προκειμένου να
                        επικυρώσουμε κι εμείς τις αξιώσεις μας έναντι του μεταφορέα.
                    </Paragraph>
                </Paper>
            </Box>
        </Box>
    );
}
